import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function ProfileButton({...params}){

    const { mode } = useContext(ThemeContext);

    let profileButtonState = params.profileButtonState
    let setProfileButtonState = params.setProfileButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-profile-light-active.svg", "/icons/icons-light/icon-profile-light-default.svg", "/icons/icons-light/icon-profile-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-profile-dark-active.svg", "/icons/icons-dark/icon-profile-dark-default.svg", "/icons/icons-dark/icon-profile-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/profilepage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setProfileButtonState('hover')
        else if (profileButtonState !== 'active') setProfileButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setProfileButtonState('default')
        if (onButtonPage) setProfileButtonState('active')
        else if (profileButtonState !== 'active') setProfileButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (profileButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (profileButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (profileButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (profileButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (profileButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (profileButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '43px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'35px'} height={'45px'} paddingBottom={'10px'}  id={"StationsButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Profile</Typography>
        </Stack>
    )
}
